import { createSlice } from "@reduxjs/toolkit";
import {
  getBooking,
  createBooking,
  login,
  getBookingHistory,
  cancelBooking,
  addToWhitelist,
  getWhitelist,
  removeFromWhitelist,
  getYacht,
  updateBookingStatus,
  updateBookingInfo,
  addOrUpdateBookCustomerDetail,
  createPaymentBill,
  getPaymentBooking,
  completeBooking,
  getBookCustomerDetail,
  getAllBooking,
  getPaymentBill,
  getBookingDetails,
  updateContractNo,
  addReview,
  getReviews,
  sendReviewChat,
  getReviewChat,
  getUnreadReviewChat,
} from "../../API/BookingAPI";

const initialState = {
  Booking: [],
  test: [],
  login: [],
  BookingHistroy: [],
  whitelistResult: null,
  whitelistResults: [],
  removeWhitelistResult: null,
  updateBookingStatusResult: null,
  yachtResult: [],
  updateBookingInfoResult: null,
  bookCustomerDetailResult: null,
  paymentBillResult: null,
  paymentBookingResult: null,
  completeBookingResult: null,
  bookCustomerDetailList: [],
  bookingAllResult: [],
  paymentBillList: [],
  bookingDetailResult: [],
  updateContractNoResult: null,
  addReviewResult: null,
  reviewList: [],
  sendReviewChatResult: null,
  reviewChat: [],
  unreadReviewChat: [],
};

export const BookingSlice = createSlice({
  name: "BookingState",
  initialState,
  reducers: {
    updateGetBooking: (state, action) => {
      state.Booking = action.payload;
    },
    updateTest: (state, action) => {
      state.test = action.payload;
    },
    updateLogin: (state, action) => {
      state.login = action.payload;
    },
    updateGetBookingHistory: (state, action) => {
      state.BookingHistroy = action.payload;
    },
    updateCancelBooking: (state, action) => {
      state.cancelBookingResult = action.payload;
    },
    updateWhitelist: (state, action) => {
      state.whitelistResult = action.payload;
    },
    updateWhitelists: (state, action) => {
      state.whitelistResults = action.payload;
    },
    updateRemoveWhitelist: (state, action) => {
      state.removeWhitelistResult = action.payload;
    },
    updateYacht: (state, action) => {
      state.yachtResult = action.payload;
    },
    updateBookingStatusResult: (state, action) => {
      state.updateBookingStatusResult = action.payload;
    },
    updateBookingInfoResult: (state, action) => {
      state.updateBookingInfoResult = action.payload;
    },
    updateBookCustomerDetailResult: (state, action) => {
      state.bookCustomerDetailResult = action.payload;
    },
    updatePaymentBillResult: (state, action) => {
      state.paymentBillResult = action.payload;
    },
    updatePaymentBookingResult: (state, action) => {
      state.paymentBookingResult = action.payload;
    },
    updateCompleteBookingResult: (state, action) => {
      state.completeBookingResult = action.payload;
    },
    updateGetBookCustomerDetail: (state, action) => {
      state.bookCustomerDetailList = action.payload;
    },
    updateBookingAllResult: (state, action) => {
      state.bookingAllResult = action.payload;
    },
    updateGetPaymentBill: (state, action) => {
      state.paymentBillList = action.payload;
    },
    updateBookingDetailResult: (state, action) => {
      state.bookingDetailResult = action.payload;
    },
    updateContractNoResult: (state, action) => {
      state.updateContractNoResult = action.payload;
    },
    updateAddReviewResult: (state, action) => {
      state.addReviewResult = action.payload;
    },
    updateReviewList: (state, action) => {
      state.reviewList = action.payload;
    },
    updateSendReviewChatResult: (state, action) => {
      state.sendReviewChatResult = action.payload;
    },
    updateReviewChat: (state, action) => {
      state.reviewChat = action.payload;
    },
    updateUnreadReviewChat: (state, action) => {
      state.unreadReviewChat = action.payload;
    },
  },
});

export const { updateGetBooking } = BookingSlice.actions;

export const getBookingDetail = (value) => async (dispatch) => {
  await getBooking(value).then(async (data) => {
    await dispatch(updateGetBooking(data));
  });
};

export const { updateGetBookingHistory } = BookingSlice.actions;

export const getBookingHistoryDetail = (value) => async (dispatch) => {
  await getBookingHistory(value).then(async (data) => {
    await dispatch(updateGetBookingHistory(data));
  });
};

export const { updateTest } = BookingSlice.actions;

export const createNewBooking = (bookingData) => async (dispatch) => {
  try {
    const data = await createBooking(bookingData);
    dispatch(updateTest(data));
    return data;
  } catch (error) { }
};

export const { updateLogin } = BookingSlice.actions;

export const LoginNew = (LoginData) => async (dispatch) => {
  try {
    const data = await login(LoginData);
    dispatch(updateLogin(data));
    return data;
  } catch (error) { }
};

export const { updateCancelBooking } = BookingSlice.actions;

export const cancelBookingAction = (bookingData) => async (dispatch) => {
  try {
    const data = await cancelBooking(bookingData);
    dispatch(updateCancelBooking(data));
    return data;
  } catch (error) { }
};

export const { updateWhitelist } = BookingSlice.actions;

export const addToWhitelistAction = (data) => async (dispatch) => {
  try {
    const result = await addToWhitelist({
      id_sellingPrice: data.yachtId,
      idUserTMY: data.idUserTMY,
    });
    dispatch(updateWhitelist(result));
    return result;
  } catch (error) {
    console.error("Error in addToWhitelistAction:", error);
    throw error;
  }
};

export const { updateYacht } = BookingSlice.actions;

export const getYachtAction = (data, token) => async (dispatch) => {
  try {
    const result = await getYacht(data, token);

    dispatch(updateYacht(result));
    return result;
  } catch (error) {
    console.error("Error in getYachtAction:", error);
    throw error;
  }
};

export const removeFromWhitelistAction = (data) => async (dispatch) => {
  try {
    const result = await removeFromWhitelist({
      id_sellingPrice: data.id_sellingPrice,
      idUserTMY: data.idUserTMY,
    });
    // ไม่ต้อง dispatch ถ้าไม่ต้องเก็บใน state
    return result;
  } catch (error) {
    console.error("Error in removeFromWhitelistAction:", error);
    throw error;
  }
};

export const { updateWhitelists } = BookingSlice.actions;

export const getWhitelistAction = (data, token) => async (dispatch) => {
  try {
    const result = await getWhitelist(data, token);

    dispatch(updateWhitelists(result));
    return result;
  } catch (error) {
    console.error("Error in getWhitelistAction:", error);
    throw error;
  }
};

export const { updateBookingStatusResult } = BookingSlice.actions;

export const updateBookingStatusAction = (data, token) => async (dispatch) => {
  try {
    const result = await updateBookingStatus(data, token);
    dispatch(updateBookingStatusResult(result));
    return result;
  } catch (error) {
    console.error("Error in updateBookingStatusAction:", error);
    throw error;
  }
};

export const { updateBookingInfoResult } = BookingSlice.actions;

export const updateBookingInfoAction = (data, token) => async (dispatch) => {
  try {
    const result = await updateBookingInfo(data, token);
    dispatch(updateBookingInfoResult(result));
    return result;
  } catch (error) {
    console.error("Error in updateBookingInfoAction:", error);
    throw error;
  }
};

export const { updateBookCustomerDetailResult } = BookingSlice.actions;

export const addOrUpdateBookCustomerDetailAction =
  (data, token) => async (dispatch) => {
    try {
      const result = await addOrUpdateBookCustomerDetail(data, token);
      dispatch(updateBookCustomerDetailResult(result));
      return result;
    } catch (error) {
      console.error("Error in addOrUpdateBookCustomerDetailAction:", error);
      throw error;
    }
  };

export const { updatePaymentBillResult } = BookingSlice.actions;

export const createPaymentBillAction = (data, token) => async (dispatch) => {
  try {
    const result = await createPaymentBill(data, token);
    dispatch(updatePaymentBillResult(result));
    return result;
  } catch (error) {
    console.error("Error in createPaymentBillAction:", error);
    throw error;
  }
};

export const { updatePaymentBookingResult } = BookingSlice.actions;

export const getPaymentBookingAction = (data, token) => async (dispatch) => {
  try {
    const result = await getPaymentBooking(data, token);
    dispatch(updatePaymentBookingResult(result));
    return result;
  } catch (error) {
    console.error("Error in getPaymentBookingAction:", error);
    throw error;
  }
};

export const { updateCompleteBookingResult } = BookingSlice.actions;

export const completeBookingAction = (data, token) => async (dispatch) => {
  try {
    const result = await completeBooking(data, token);
    dispatch(updateCompleteBookingResult(result));
    return result;
  } catch (error) {
    console.error("Error in completeBookingAction:", error);
    throw error;
  }
};

export const { updateGetBookCustomerDetail } = BookingSlice.actions;

export const getBookCustomerDetailAction =
  (data, token) => async (dispatch) => {
    try {
      const result = await getBookCustomerDetail(data, token);
      dispatch(updateGetBookCustomerDetail(result));
      return result;
    } catch (error) {
      console.error("Error in getBookCustomerDetailAction:", error);
      throw error;
    }
  };

export const { updateBookingAllResult } = BookingSlice.actions;

export const getAllBookingAction = (data, token) => async (dispatch) => {
  try {
    const result = await getAllBooking(data, token);
    dispatch(updateBookingAllResult(result));
    return result;
  } catch (error) {
    console.error("Error in getAllBookingAction:", error);
    throw error;
  }
};

export const { updateGetPaymentBill } = BookingSlice.actions;

export const getPaymentBillAction = (data, token) => async (dispatch) => {
  try {
    const result = await getPaymentBill(data, token);
    dispatch(updateGetPaymentBill(result));
    return result;
  } catch (error) {
    console.error("Error in getPaymentBillAction:", error);
    throw error;
  }
};

export const { updateBookingDetailResult } = BookingSlice.actions;

export const getBookingDetailAction = (data, token) => async (dispatch) => {
  try {
    const result = await getBookingDetails(data, token);
    dispatch(BookingSlice.actions.updateBookingDetailResult(result));
    return result;
  } catch (error) {
    console.error("Error in getBookingDetailAction:", error);
    throw error;
  }
};

export const { updateContractNoResult } = BookingSlice.actions;

export const updateContractNoAction = (data, token) => async (dispatch) => {
  try {
    const result = await updateContractNo(data, token);
    dispatch(updateContractNoResult(result));
    return result;
  } catch (error) {
    console.error("Error in updateContractNoAction:", error);
    throw error;
  }
};

export const { updateAddReviewResult } = BookingSlice.actions;

export const addReviewAction = (data, token) => async (dispatch) => {
  try {
    const result = await addReview(data, token);
    dispatch(updateAddReviewResult(result));
    return result;
  } catch (error) {
    console.error("Error in addReviewAction:", error);
    throw error;
  }
};

export const { updateReviewList } = BookingSlice.actions;

export const getReviewListAction = (data, token) => async (dispatch) => {
  try {
    const result = await getReviews(data, token);
    dispatch(updateReviewList(result));
    return result;
  } catch (error) {
    console.error("Error in getReviewListAction:", error);
    throw error;
  }
};

export const { updateSendReviewChatResult } = BookingSlice.actions;

export const sendReviewChatAction = (data, token) => async (dispatch) => {
  try {
    const result = await sendReviewChat(data, token);
    dispatch(updateSendReviewChatResult(result));
    return result;
  } catch (error) {
    console.error("Error in sendReviewChatAction:", error);
    throw error;
  }
};

export const { updateReviewChat } = BookingSlice.actions;

export const getReviewChatAction = (data, token) => async (dispatch) => {
  try {
    const result = await getReviewChat(data, token);
    dispatch(updateReviewChat(result));
    return result;
  } catch (error) {
    console.error("Error in getReviewChatAction:", error);
    throw error;
  }
};

export const { updateUnreadReviewChat } = BookingSlice.actions;

export const getUnreadReviewChatAction = (data, token) => async (dispatch) => {
  try {
    const result = await getUnreadReviewChat(data, token);
    dispatch(updateUnreadReviewChat(result));
    return result;
  } catch (error) {
    console.error("Error in getUnreadReviewChatAction:", error);
    throw error;
  }
};

export default BookingSlice.reducer;
